module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSave()
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "x12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    attrs: {
      "label": "Company Name:",
      "readonly": "",
      "placeholder": _vm.CompanyInfoForm.companylegalname,
      "auto-grow": "",
      "required": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    attrs: {
      "label": "Address Line 1:",
      "placeholder": "Address1",
      "auto-grow": "",
      "required": "",
      "disabled": _vm.readonly
    },
    model: {
      value: (_vm.CompanyInfoForm.addressline1),
      callback: function($$v) {
        _vm.$set(_vm.CompanyInfoForm, "addressline1", $$v)
      },
      expression: "CompanyInfoForm.addressline1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    attrs: {
      "label": "Address Line 2:",
      "placeholder": "Address2",
      "auto-grow": "",
      "disabled": _vm.readonly
    },
    model: {
      value: (_vm.CompanyInfoForm.addressline2),
      callback: function($$v) {
        _vm.$set(_vm.CompanyInfoForm, "addressline2", $$v)
      },
      expression: "CompanyInfoForm.addressline2"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    attrs: {
      "label": "City:",
      "placeholder": "city",
      "auto-grow": "",
      "required": "",
      "disabled": _vm.readonly
    },
    model: {
      value: (_vm.CompanyInfoForm.city),
      callback: function($$v) {
        _vm.$set(_vm.CompanyInfoForm, "city", $$v)
      },
      expression: "CompanyInfoForm.city"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    attrs: {
      "label": "County:",
      "placeholder": "county",
      "auto-grow": "",
      "required": "",
      "disabled": _vm.readonly
    },
    model: {
      value: (_vm.CompanyInfoForm.county),
      callback: function($$v) {
        _vm.$set(_vm.CompanyInfoForm, "county", $$v)
      },
      expression: "CompanyInfoForm.county"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    attrs: {
      "label": "Zip:",
      "placeholder": "zip",
      "auto-grow": "",
      "required": "",
      "disabled": _vm.readonly
    },
    model: {
      value: (_vm.CompanyInfoForm.zip),
      callback: function($$v) {
        _vm.$set(_vm.CompanyInfoForm, "zip", $$v)
      },
      expression: "CompanyInfoForm.zip"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-select', {
    staticClass: "pr-2 mt-0",
    attrs: {
      "items": ['AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VT', 'WA', 'WI', 'WV', 'WY'],
      "required": "",
      "label": "State:",
      "disabled": _vm.readonly
    },
    model: {
      value: (_vm.CompanyInfoForm.state),
      callback: function($$v) {
        _vm.$set(_vm.CompanyInfoForm, "state", $$v)
      },
      expression: "CompanyInfoForm.state"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    attrs: {
      "placeholder": _vm.CompanyInfoForm.businesswebsite,
      "disabled": _vm.readonly,
      "label": "Company Website:",
      "auto-grow": "",
      "required": ""
    },
    model: {
      value: (_vm.CompanyInfoForm.businesswebsite),
      callback: function($$v) {
        _vm.$set(_vm.CompanyInfoForm, "businesswebsite", $$v)
      },
      expression: "CompanyInfoForm.businesswebsite"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    attrs: {
      "label": "Public Contact Phone Number:",
      "disabled": _vm.readonly,
      "placeholder": "Phone Number",
      "required": ""
    },
    model: {
      value: (_vm.CompanyInfoForm.phonenumber),
      callback: function($$v) {
        _vm.$set(_vm.CompanyInfoForm, "phonenumber", $$v)
      },
      expression: "CompanyInfoForm.phonenumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    attrs: {
      "label": "Public contact Email Address:",
      "disabled": _vm.readonly,
      "placeholder": _vm.user.email,
      "readonly": "",
      "required": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    attrs: {
      "label": "Description:",
      "placeholder": "Description",
      "disabled": _vm.readonly,
      "required": ""
    },
    model: {
      value: (_vm.CompanyInfoForm.companydescription),
      callback: function($$v) {
        _vm.$set(_vm.CompanyInfoForm, "companydescription", $$v)
      },
      expression: "CompanyInfoForm.companydescription"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "xs12": "",
      "id": "await_p"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "red"
    }
  }, [_vm._v("You have already entered a company. It is awaiting moderation.")])])], 1), _vm._v(" "), (_vm.saved) ? _c('v-btn', {
    attrs: {
      "primary": "",
      "id": "next"
    },
    on: {
      "click": function($event) {
        return _vm.onNext()
      }
    }
  }, [_vm._v("Next")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('v-btn', {
    attrs: {
      "primary": "",
      "secondary": "",
      "type": "submit",
      "id": "savenext"
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d84f0308","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/questionaire/CompanyInformationForm.vue
// module id = 1238
// module chunks = 14 15